module.exports = __webpack_public_path__ + "img/7.6b2b6d51.png";